import styled from 'styled-components';
import logo from 'assets/images/Warwick.svg';
import { mixins } from '../../design-system';
import { tokens } from 'design-tokens/warwick/tokens';
/**
 * TV-Optimized Header Bar Styles
 * - No backdrop-filter or heavy blur effects
 * - No box-shadow
 * - Simple transforms and opacity animations only
 * - Hardware acceleration with translate3d
 */

export const HeaderBar = styled.div`
  ${mixins.flexSpaceBetween}
  height: 127px;
  padding: 0 ${tokens.primitive.space[40]};
  background-color: ${tokens.semantic.color.background.topbar};
  align-items: center;
`;

export const WarwickLogo = styled.div`
  background: url(${logo}) no-repeat center left;
  background-size: contain;
  width: ${tokens.semantic.size.appIcon.width};
  height: ${tokens.semantic.size.appIcon.height};
`;

/** Same footprint as Logo; wraps CachedImg for API-provided logos */
export const LogoImageSlot = styled.div`
  width: ${tokens.semantic.size.appIcon.width};
  height: ${tokens.semantic.size.appIcon.height};
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-shrink: 0;

  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    object-position: left center;
  }
`;

export const HeaderSection = styled.div`
  ${mixins.flexCenterVertical}
  > * + * {
    margin-inline-start: ${tokens.primitive.space[50]};
  }
`;

export const WelcomeWrapper = styled.div`
  ${mixins.flexColumn}
  > * + * {
    margin-top: ${tokens.primitive.space[5]};
  }
`;

export const WelcomeText = styled.div`
  ${mixins.textWelcomeHeading}
`;

export const GuestName = styled.div`
  ${mixins.textGuestName}
`;
